import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import env from "../../services/env.js";
import security from "../../services/security.js";

class Onboarding2Controller {
  constructor($http, $state, $stateParams, $location, $timeout, AuthService, $rootScope, $cookies, TrackingService) {
    this.name = "onboarding2";
    this.$http = $http;
    this.$state = $state;
    this.$cookies = $cookies;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.$auth = AuthService;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.currentUser = this.$auth.getUserData();
    this.remain_loading_count = 0;
    this.$tracking = TrackingService;

    console.log("what is this shit");
    console.dir(this.$rootScope.postTypeForOnoarding);

    var _this = this;
  }

  logOnboardingTracking(step) {
    var _this = this;

    if (_this.currentUser) {
      if (_this.currentUser.username.indexOf("jobble.com") === -1 || _this.currentUser.username.indexOf("jobbleapp.com") === -1) {
        _this.$tracking.reportOboardingScreenTwo(step);
      }
    } else {
      _this.$tracking.reportOboardingScreenTwo(step);
    }
  }
}

Onboarding2Controller.$inject = ["$http", "$state", "$stateParams", "$location", "$timeout", "auth", "$rootScope", "$cookies", "tracking"];

export default Onboarding2Controller;



// WEBPACK FOOTER //
// ./client/app/components/onboarding2/onboarding2.controller.js